import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  increment,
  where,
  orderBy,
  startAfter,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "articles", id);
};

export const getArticles = async (last, category) => {
  try {
    // Query to get the articles
    let q = category
      ? query(
          collection(db, "articles"),
          where("categories", "array-contains", category),
          orderBy("createdAt", "desc"),
          ...(last ? [startAfter(last)] : []),
          limit(10)
        )
      : query(
          collection(db, "articles"),
          orderBy("createdAt", "desc"),
          ...(last ? [startAfter(last)] : []),
          limit(10)
        );

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const articles = documentSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    // Get the total count of articles in the collection
    let countQuery = category
      ? query(
          collection(db, "articles"),
          where("categories", "array-contains", category),
          orderBy("createdAt", "desc"),
        )
      : query(
          collection(db, "articles"),
          orderBy("createdAt", "desc"),
        );
    const countSnapshot = await getCountFromServer(countQuery);
    const totalArticlesCount = countSnapshot.data().count;

    // Return articles, last document, and total count of articles
    return { articles, last: lastVisible, totalArticlesCount };
  } catch (error) {
    console.error(`Error while getting articles: ${error}`);
    return error;
  }
};

export const getArticleById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const article = docSnap.data();
  if (docSnap.exists) {
    updateDoc(getDocument(id), { views: increment(1) });
    return { ...article, id: docSnap.id };
  }
};

export const getArticlesByCategory = async (category) => {
  try {
    const q = query(
      collection(db, "articles"),
      where("categories", "array-contains", category),
      orderBy("createdAt", "desc"),
      // where("published", "==", true)
    );
    const docSnapshots = await getDocs(q);

    const articles = docSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    return articles;
  } catch (error) {
    console.error(`Error while getting articles by category ${error}`);
    return error;
  }
};
